import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import {
  ETranscoderTaskKind,
  TranscoderReservedNamesError,
  TranscoderTask,
  TranscoderTemplate,
} from '../../models/transcoder';

const isValidTranscoderTemplate = (item: TranscoderTemplate) => item.audioProfiles || item.videoProfiles;
const isValidTranscoderTask = (item: TranscoderTask) =>
  item.audioMap || item.videoMap || (item.kind && item.outputFolder && item.kind === ETranscoderTaskKind.vod);

// isReservedNamesError check if error from backend response is kind of ReservedNamesError
export const isTranscoderReservedNamesError = (
  error: TranscoderReservedNamesError,
): error is TranscoderReservedNamesError => {
  return 'detail' in error && 'names' in error && 'kind' in error && 'status' in error;
};

export const transfromTranscoderErrors = <T>(response: FetchBaseQueryError, arg: T) => {
  // eslint-disable-next-line
  const data: any = response.data;

  if (
    data.errors &&
    Array.isArray(data.errors) &&
    data.errors.length &&
    isTranscoderReservedNamesError(data.errors[data.errors.length - 1])
  ) {
    const error: TranscoderReservedNamesError = data.errors[data.errors.length - 1];

    if (isValidTranscoderTemplate(arg as TranscoderTemplate)) {
      (arg as TranscoderTemplate).reservedNames = [
        {
          kind: error.kind,
          names: error.names,
        },
      ];
    } else if (isValidTranscoderTask(arg as TranscoderTask)) {
      (arg as TranscoderTask).reservedNames = [
        {
          kind: error.kind,
          names: error.names,
        },
      ];
    }
  }

  return response;
};
